module.exports = {
  status:"hardware",
    //id: "https://ohstem.vn/knowledge-base/plantbit/",
    id:"https://ohshop.vn/product/plantbit-bo-kit-tuoi-cay-thong-minh/",
    title: "Plant:Bit",
    detail:
      'Plant:Bit giúp bạn tự mình thiết kế một khu vườn thông minh có thể tự động chăm sóc.',
    image: "/assets/tutorials/courses/tuoicay.jpg",
    categoryIds: ["hardware"],
    //label: "Mới bắt đầu?",
    labelClass: "green ribbon huge",
    toolbox: [
      {
        category: "basic",
        blocks: ["yolobit_basic_scroll_text", "yolobit_basic_forever"]
      }
    ],
    steps: [
      {
       
      }
    ]
  };
  